import { Injectable } from "@angular/core";
import { TokenService } from "src/app/auth/token.service";
import { RoleEnum } from "../Models/enums/RoleEnum";
import { PermissionsEnum } from "../Models/enums/PermissionsEnum";

@Injectable({
  providedIn: "root",
})
export class PermissionsService {
  constructor(protected tokenService: TokenService) {}

  allowed(permission: PermissionsEnum): boolean {
    var roles = this.permissionTree[permission];

    if (!roles?.length) return false;

    return this.tokenService.hasSomeRole(roles);
  }

  private permissionTree = {
    [PermissionsEnum.StartSurvey]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.ViewSurvey]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Viewer,
      RoleEnum.Planner,
      RoleEnum.OperationAdmin,
    ],
    [PermissionsEnum.EditSurvey]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
    ],
    [PermissionsEnum.AddBuildingsToBuildingGroup]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
    ],
    [PermissionsEnum.RemoveBuildingsFromBuildingGroup]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
    ],
    [PermissionsEnum.CreateBuilding]: [
      RoleEnum.Admin,
      RoleEnum.Planner,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
    ],
    [PermissionsEnum.MoveBuildingToBlock]: [RoleEnum.Admin, RoleEnum.Validator],
    [PermissionsEnum.ValidateSurvey]: [RoleEnum.Admin, RoleEnum.Validator],
    [PermissionsEnum.AssignSurveyToMe]: [
      RoleEnum.Admin,
      RoleEnum.Planner,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
    ],
    [PermissionsEnum.SetSurveyBackToOngoing]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
    ],
    [PermissionsEnum.PrefillSurvey]: [RoleEnum.Admin, RoleEnum.Validator],
    [PermissionsEnum.ReassignAddress]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.DeleteAddress]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.ReassignSurvey]: [RoleEnum.Admin],
    [PermissionsEnum.SurveyHistory]: [RoleEnum.Admin, RoleEnum.Validator, RoleEnum.OperationAdmin],
    [PermissionsEnum.ViewCommandUploads]: [
      RoleEnum.Admin,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Viewer,
      RoleEnum.Planner,
      RoleEnum.OperationAdmin,
    ],
    [PermissionsEnum.UserManager]: [RoleEnum.Admin, RoleEnum.OperationAdmin],
    [PermissionsEnum.EditDocumentList]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.EditContacts]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.PrintDocuments]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
      RoleEnum.Planner,
    ],
    [PermissionsEnum.EditMainDistribution]: [
      RoleEnum.Admin,
      RoleEnum.Validator,
    ],
    [PermissionsEnum.EditAreaContacts]: [RoleEnum.Admin],
    [PermissionsEnum.RestartCommand]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.RetryCommand]: [RoleEnum.Admin, RoleEnum.OperationAdmin],
    [PermissionsEnum.ExportFieldsConfiguration]: [RoleEnum.Admin],
    [PermissionsEnum.BulkConfiguration]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.TriggerInitialLoad]: [RoleEnum.Admin],
    [PermissionsEnum.ViewTemplates]: [
      RoleEnum.Admin,
      RoleEnum.Planner,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Viewer,
    ],
    [PermissionsEnum.ManageDocumentTemplates]: [
      RoleEnum.Admin,
      RoleEnum.OperationAdmin,
    ],
    [PermissionsEnum.ExportLstData]: [
      RoleEnum.Admin,
      RoleEnum.Planner,
      RoleEnum.Surveyor,
      RoleEnum.Validator,
      RoleEnum.Manager,
      RoleEnum.Viewer,
    ],
    [PermissionsEnum.LomImport]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.BulkUpload]: [RoleEnum.Admin, RoleEnum.OperationAdmin],
    [PermissionsEnum.RefreshBuilding]: [
      RoleEnum.Admin,
      RoleEnum.OperationAdmin,
    ],
    [PermissionsEnum.ForceStartSurvey]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.OpenEmptyBuildingsList]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.ForceRollBack]: [RoleEnum.OperationAdmin],
    [PermissionsEnum.Settings]: [RoleEnum.Admin, RoleEnum.OperationAdmin],
    [PermissionsEnum.GeneralSettings]: [RoleEnum.OperationAdmin],
  };
}
